import React from "react";
import "../../../styles/desktop/statusExaustor.css";

import CircleOn from "../../../assets/svg/circleOn";
import CircleOff from "../../../assets/svg/circleOff";
import CircleExpired from "../../../assets/svg/circleExpired";

const CircleStatus = ({ status, width, height, onClick }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    if (status === "on") {
        return <CircleOn width={width} height={height} onClick={handleClick} />;
    } else if (status === "expired") {
        return <CircleExpired width={width} height={height} onClick={handleClick} />;
    } else {
        return <CircleOff width={width} height={height} onClick={handleClick} />;
    }
};

export default CircleStatus;